import Sentry from "@similarweb/sentry-logger";

import type { IFetchService } from "app/services/fetchService";
import { fetchSimilarSitesQuery } from "app/services/sitesService/queries/sitesQueries";

import type { AICompetitorsSuggestion, SuggestedCompetitors } from "../../types/api";
import { ACTIVATION_API } from "../constants";

type SetupApiServiceSchema = {
    getSuggestedCompetitors: (domain: string) => Promise<SuggestedCompetitors[]>;
    getAISuggestedCompetitors: (
        mainDomain: string,
        country: number,
        refinementMessage: string,
        threadId: string,
        locale: string,
    ) => Promise<AICompetitorsSuggestion>;
};

export const setupApiService = (fetchService: IFetchService): SetupApiServiceSchema => ({
    getSuggestedCompetitors: async (domain: string) => {
        try {
            const response = await fetchSimilarSitesQuery(domain, { limit: 30 });
            return response as unknown as SuggestedCompetitors[];
        } catch (error) {
            Sentry.error("Setup - error when fetching competitors", error);
            return null;
        }
    },
    getAISuggestedCompetitors: async (
        mainDomain: string,
        country: number,
        refinementMessage: string,
        threadId: string,
        locale: string,
    ) => {
        try {
            return await fetchService.get(`${ACTIVATION_API}/competitors`, {
                mainDomain,
                country,
                refinementMessage,
                threadId,
                locale,
            });
        } catch (error) {
            Sentry.error("Setup - error when fetching competitors AI", error);
            return null;
        }
    },
});
